const initState = {
  buttonClicked: null,
  cookiesAccepted: null
};

const cookieReducer = (state = initState, action) => {
  switch (action.type) {
    case "COOKIES_ACCEPTED":
      return {
        ...state,
        buttonClicked: true,
        cookiesAccepted: true
      };
    case "COOKIES_DECLINED":
      return {
        ...state,
        buttonClicked: true,
        cookiesAccepted: false
      };
    default:
      return state;
  }
};

export default cookieReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/cookieReducer.tsx